import { flow, getParent, types } from "mobx-state-tree";
import moment from "moment";
import { SAPSelect } from "../../models/CommonModel";
import apiCall from "../../scripts/apiCall";

const QuoteItem = types
  .model("QuoteItem", {
    Quotenr: types.string,
    Itemnr: types.string,
    Materialnr: types.string,
    Materialtext: types.string,
    CustomerMatID: types.string,
    CustomerMatText: types.string,
    Packagingcode: types.string,
    Packaging: types.string,
    Quantity: types.string,
    Salesunit: types.string,
    PriceUnit: types.string,
    Price: types.string,
    PricePerTon: types.string,
    Oldpricedate: types.string,
    Oldprice: types.string,
    OldPriceUnit: types.string,
    MaterialBlocked: types.optional(types.string, ""),
  })
  .views((self) => ({
    get canSave() {
      return (
        self.Materialnr !== "" &&
        self.Materialtext !== "null" &&
        self.Packagingcode !== "" &&
        self.Packaging !== "null" &&
        self.Quantity !== "" &&
        self.PricePerTon !== "" &&
        parseFloat(self.Quantity) > 0 &&
        parseFloat(self.PricePerTon) > 0
      );
    },
  }))
  .actions((self) => ({
    change: (val, prop) => {
      self[prop] = val;
    },
  }));
const QuoteHeader = types
  .model("QuoteHeader", {
    Quotenr: types.optional(types.string, ""),
    Shiptonr: types.optional(types.string, ""),
    Shiptoname: types.optional(types.string, ""),
    Shiptocountry: types.optional(types.string, ""),
    Shiptopostcode: types.optional(types.string, ""),
    Shiptocity: types.optional(types.string, ""),
    Soldtonr: types.optional(types.string, ""),
    Soldtoname: types.optional(types.string, ""),
    Soldtocountry: types.optional(types.string, ""),
    Soldtopostcode: types.optional(types.string, ""),
    Soldtocity: types.optional(types.string, ""),
    Status: types.optional(types.string, ""),
    ValidTo: types.maybeNull(types.Date),
    Validfrom: types.maybeNull(types.Date),
    ReqDel: types.maybeNull(types.Date),
    Salesorg: types.optional(types.string, ""),
    Salesrep: types.optional(types.frozen(), null),
    Incoterm1: types.optional(types.string, ""),
    IncotermDesc: types.optional(types.string, ""),
    Incoterm2: types.optional(types.string, ""),
    Shipmentterm: types.optional(types.string, ""),
    ShipmenttermDesc: types.optional(types.string, ""),
    Paymentterm: types.optional(types.string, ""),
    PaymenttermDesc: types.optional(types.string, ""),
    Currency: types.optional(types.string, ""),
    Internaltext: types.optional(types.string, ""),
    Externaltext: types.optional(types.string, ""),
    Doctype: types.optional(types.string, ""),
    toCustomer: types.optional(types.boolean, true),
    Reference: "",
    Items: types.optional(types.array(QuoteItem), []),
    // Netvalue: "17966.00",
  })
  .views((self) => {
    return {
      get validity() {
        return (
          moment(self.Validfrom).format("DD-MM-yyyy") +
          " TO " +
          moment(self.ValidTo).format("DD-MM-yyyy")
        );
      },
      get Parent() {
        return getParent(self);
      },
      get validShipInco() {
        console.log("relationcheck");
        const rel = self.Parent.relation;
        // = {
        //   NI: ["EXW"],
        //   N3: ["DAP"],
        //   E2: ["FCA"],
        //   E3: ["DAP", "DDP"],
        //   EX: ["DAP", "DDP"],
        //   OT: ["DAP"],
        //   NT: ["DAP"],
        //   TR: ["DAP"],
        //   M2: ["EXW"],
        //   M3: ["DAP", "DDP"],
        //   L3: ["EXW"],
        //   SE: ["CIF", "CFR", "DAP"],
        //   T2: ["FCA"],
        //   AI: ["CIF", "CFR", "DAP"],
        //   A2: ["FCA"],
        //   A3: ["CIF", "CFR", "DAP"],
        // };
        return (
          rel[self.Shipmentterm] &&
          rel[self.Shipmentterm].includes(self.Incoterm1)
        );
      },
      get validInco2() {
        console.log("inco2");
        if (
          self.Incoterm1 === "CIF" ||
          self.Incoterm1 === "CFR" ||
          self.Incoterm1 === "FOB"
        ) {
          if (self.Incoterm2 === "") {
            return false;
          } else {
            return self.Parent.inco2[self.Incoterm2];
          }
        }
        return true;
      },
      get canSave() {
        return (
          self.Salesrep !== null &&
          self.Doctype !== "" &&
          self.Currency !== "" &&
          self.Validfrom &&
          self.ValidTo &&
          self.Paymentterm &&
          self.Shipmentterm &&
          self.Incoterm1 !== "" &&
          self.Incoterm2 !== "" &&
          self.Items.length !== 0 &&
          self.Items.filter((it) => !it.canSave).length === 0
        );
      },
    };
  })
  .actions((self) => ({
    sortItems: (field, dir, arr) => {
      if (arr) {
        self.Items = arr.sort(function (a, b) {
          var nr = 0;
          if (dir !== 0) {
            if (a[field].toUpperCase() < b[field].toUpperCase()) {
              nr = -1;
            } else {
              if (a[field].toUpperCase() > b[field].toUpperCase()) {
                nr = 1;
              } else {
                if (
                  a.Quantity.length > b.Quantity.length ||
                  parseFloat(a.Quantity) > parseFloat(b.Quantity)
                ) {
                  nr = 1;
                } else {
                  nr = -1;
                }
              }
            }
          }
          return nr * dir;
        });
      } else {
        self.Items = self.Items.sort(function (a, b) {
          var nr = 0;
          if (dir !== 0) {
            if (a[field].toUpperCase() < b[field].toUpperCase()) {
              nr = -1;
            } else {
              if (a[field].toUpperCase() > b[field].toUpperCase()) {
                nr = 1;
              } else {
                if (
                  a.Quantity.length > b.Quantity.length ||
                  parseFloat(a.Quantity) > parseFloat(b.Quantity)
                ) {
                  nr = 1;
                } else {
                  nr = -1;
                }
              }
            }
          }
          return nr * dir;
        });
      }
    },
    addItem: (val, field, dir) => {
      var arr = [...self.Items];
      arr.push({
        Quotenr: self.Quotenr,
        Itemnr: "",
        Materialnr: "",
        Materialtext: "",
        Packagingcode: "",
        Packaging: "",
        Quantity: "",
        Salesunit: "",
        PriceUnit: "",
        Price: "",
        PricePerTon: "",
        Oldpricedate: "",
        Oldprice: "",
        OldPriceUnit: "",
        ...val,
      });
      self.sortItems(field, dir, [...arr]);
    },
    delItem: (val) => {
      self.Items = self.Items.filter((_, i) => i !== val);
    },
    change: (val, prop) => {
      self[prop] = val;
    },
  }));
export const QuoteDataModel = types.compose(
  types
    .model("QuoteData", {
      loading: false,
      date: types.Date,
      Nr: "10",
      ActiveQuote: types.maybeNull(QuoteHeader),
      Quotes: types.optional(types.array(QuoteHeader), []),
    })
    .views((self) => {
      return {
        get Parent() {
          return getParent(self);
        },
      };
    })
    .actions((self) => {
      return {
        afterCreate: () => {
          console.log("created");
        },
        changeLoading: (val) => {
          self.loading = val;
        },
        getQuotes: (soldTo, shipTo, date = null) => {
          self.loading = true;
          let fetchOptions = {
            method: "POST",
            credentials: "same-origin",

            body: JSON.stringify({
              proj: "Z_GW_ARCH_ORDER_SRV",
              funct: "QuotationHeaderSet",
              parameters: `$top=20&$filter=Soldtonr eq '${soldTo}' and Shiptonr eq '${shipTo}' and Validfrom eq '${
                date
                  ? moment(date).format("YYYYMMDD")
                  : moment(self.date).format("YYYYMMDD")
              }'&$format=json&$expand=QuoteHeaderToItemNAV`,
            }),
          };
          var sys = window.localStorage.getItem("QUOTEsys");
          let url = `SAPOData${sys}`;
          apiCall(
            url,
            fetchOptions,
            (json) => {
              var arr = json.results;
              arr.forEach((jel) => {
                console.log(jel);
                jel.Internaltext = jel.Internaltext.replace(/&nbsp;/g, " ");
                jel.Externaltext = jel.Externaltext.replace(/&nbsp;/g, " ");
                jel.Quotenr = parseInt(jel.Quotenr).toString();
                jel.Quotenr = parseInt(jel.Quotenr).toString();
                jel.ReqDel = new Date(jel.ReqDel);
                jel.ValidTo = new Date(jel.ValidTo);
                jel.Validfrom = new Date(jel.Validfrom);
                jel.Salesrep =
                  jel.Salesrep !== ""
                    ? { label: jel.Salesrep, value: jel.Salesrep }
                    : null;
              });
              self.changeLoading(false);
              self.setQuotes(
                arr.sort((a, b) => {
                  if (a.Salesorg === b.Salesorg) return 0;
                  if (a.Salesorg === self.Parent.SalesOrg.Id) return -1;
                  if (b.Salesorg === self.Parent.SalesOrg.Id) return 1;
                  return a.Salesorg < b.Salesorg ? -1 : 1;
                })
              );
            },
            self.Parent.instance,
            self.Parent.accounts
          );
        },
        getLastQuotes: (soldTo, shipTo, date = null) => {
          self.loading = true;
          let fetchOptions = {
            method: "POST",
            credentials: "same-origin",

            body: JSON.stringify({
              proj: "Z_GW_ARCH_ORDER_SRV",
              funct: "QuotationHeaderSet",
              parameters: `$top=${self.Nr}&$filter=Soldtonr eq '${soldTo}' and Shiptonr eq '${shipTo}' and Quotenr eq '000'&$format=json&$expand=QuoteHeaderToItemNAV`,
            }),
          };
          var sys = window.localStorage.getItem("QUOTEsys");
          let url = `SAPOData${sys}`;
          apiCall(
            url,
            fetchOptions,
            (json) => {
              var arr = json["results"];
              arr.forEach((jel) => {
                console.log(jel);
                jel.Internaltext = jel.Internaltext.replace(/&nbsp;/g, " ");
                jel.Externaltext = jel.Externaltext.replace(/&nbsp;/g, " ");
                jel.Quotenr = parseInt(jel.Quotenr).toString();
                jel.Quotenr = parseInt(jel.Quotenr).toString();
                jel.ReqDel = new Date(jel.ReqDel);
                jel.ValidTo = new Date(jel.ValidTo);
                jel.Validfrom = new Date(jel.Validfrom);
                jel.Salesrep =
                  jel.Salesrep !== ""
                    ? { label: jel.Salesrep, value: jel.Salesrep }
                    : null;
              });
              console.log(arr);
              console.log(arr.QuoteHeaderToItemNAV);
              self.changeLoading(false);
              self.setQuotes(
                arr.sort((a, b) => {
                  if (a.Salesorg === b.Salesorg) return 0;
                  if (a.Salesorg === self.Parent.SalesOrg.Id) return -1;
                  if (b.Salesorg === self.Parent.SalesOrg.Id) return 1;
                  return a.Salesorg < b.Salesorg ? -1 : 1;
                })
              );
            },
            self.Parent.instance,
            self.Parent.accounts
          );
        },
        getQuote: (soldTo, shipTo, nr, type) => {
          self.loading = true;
          let fetchOptions = {
            method: "POST",
            credentials: "same-origin",

            body: JSON.stringify({
              proj: "Z_GW_ARCH_ORDER_SRV",
              funct: "QuotationHeaderSet",
              parameters: `$top=20&$filter=Soldtonr eq '${soldTo}' and Shiptonr eq '${shipTo}' and Quotenr eq '${nr}'&$format=json&$expand=QuoteHeaderToItemNAV`,
            }),
          };
          var sys = window.localStorage.getItem("QUOTEsys");
          let url = `SAPOData${sys}`;

          apiCall(
            url,
            fetchOptions,
            ({ results }) => {
              console.log(results);

              results.forEach((jel) => {
                jel.Quotenr = parseInt(jel.Quotenr).toString();
                jel.ReqDel = new Date(jel.ReqDel);
                jel.ValidTo = new Date(jel.ValidTo);
                jel.Validfrom = new Date(jel.Validfrom);
                jel.Salesrep =
                  jel.Salesrep !== ""
                    ? { label: jel.Salesrep, value: jel.Salesrep }
                    : null;
                jel.Items = jel.QuoteHeaderToItemNAV.results;
              });
              self.changeLoading(false);
              try {
                self.setQuote(results[0], type);
              } catch (error) {
                console.log("no latest quote");
                console.log(error);
              }
            },
            self.Parent.instance,
            self.Parent.accounts
          );
        },
        setQuotes: (val) => {
          self.Quotes = val
            .map((el) => ({
              ...el,
              Items: el.QuoteHeaderToItemNAV.results.map((it) => ({
                ...it,
                Quantity: parseInt(it.Quantity).toString(),
                Price: parseInt(it.Price).toString(),
                PricePerTon: parseInt(it.PricePerTon).toString(),
              })),
            }))
            .sort((a, b) => (a.Quotenr > b.Quotenr ? 1 : 0));
        },
        setQuote: (val, type) => {
          val.Items = val.Items.map((el) => ({
            ...el,
            Quantity: parseInt(el.Quantity).toString(),
            Price: parseInt(el.Price).toString(),
            PricePerTon: parseInt(el.PricePerTon).toString(),
          }));
          self.Parent.selectQuote({
            ...val,
            ReqDel: new Date(val.ReqDel).getTime(),

            Validfrom:
              type === "replace"
                ? new Date(val.Validfrom).getTime()
                : new Date(val.ValidTo).setDate(val.ValidTo.getDate() + 1),
            ValidTo:
              type === "replace" ? new Date(val.ValidTo).getTime() : null,
            toCustomer: false,
            Items: val.Items.map((qel) => ({
              ...qel,
              Oldprice: qel.PricePerTon,
              PricePerTon: type === "extend" ? qel.PricePerTon : "",
            })),
          });
        },
        setDate: (val) => {
          self.date = val;
        },
        setNr: (val) => {
          self.Nr = val;
        },
      };
    })
);

const SSPModel = types.model("SSPModel", {
  Payer: types.string,
  PayerName: types.string,
  SalesOrg: types.string,
  ShipTo: types.string,
  ShipToCountry: types.optional(types.string, ""),
  ShipToLocation: types.string,
  ShipToPostcode: types.optional(types.string, ""),
  ShipToStreetNr: types.optional(types.string, ""),
  ShipToName: types.string,
  SoldTo: types.string,
  SoldToCountry: types.optional(types.string, ""),
  SoldToName: types.string,
  SoldToPostcode: types.optional(types.string, ""),
  SoldToCity: types.optional(types.string, ""),
  Y2id: types.optional(types.string, ""),
  Y2fax: types.optional(types.string, ""),
  Y2name: types.optional(types.string, ""),
  Y2mail: types.optional(types.string, ""),
  Z2id: types.optional(types.string, ""),
  Z2name: types.optional(types.string, ""),
  Z2fax: types.optional(types.string, ""),
  Z2mail: types.optional(types.string, ""),
  DefaultIncoterm1: types.optional(types.string, ""),
  DefaultIncoterm2: types.optional(types.string, ""),
  DefaultPaymentterm: types.optional(types.string, ""),
  DefaultShipmentterm: types.optional(types.string, ""),
  DefaultCurrency: types.optional(types.string, ""),
  LastQuote: types.optional(types.string, ""),
  QuoteFrom: types.optional(types.string, ""),
  QuoteTo: types.optional(types.string, ""),
});
export const QuoteCustomerModel = types.compose(
  types
    .model("QuoteCustomerModel", {
      loading: types.optional(types.boolean, false),
      sapSys: types.optional(types.string, "PS4"),
      Customer: types.maybeNull(SAPSelect, null),
      SalesOrg: types.maybeNull(SAPSelect, null),
      SSP: types.optional(types.array(SSPModel), []),
      SelectedSSP: types.optional(types.integer, -1),
      SelectedQuote: types.maybeNull(QuoteHeader),
      quoteData: types.maybeNull(QuoteDataModel),
      relation: types.frozen({}),
      inco2: types.frozen({}),
      instance: types.frozen(),
      accounts: types.frozen(),
    })
    .views((self) => {
      return {
        get SSPItem() {
          return self.SSP[self.SelectedSSP];
        },
      };
    })
    .actions((self) => {
      return {
        afterCreate: () => {
          let cus = window.localStorage.getItem("MatCus");
          let so = window.localStorage.getItem("MatSO");

          if (cus !== undefined && cus !== null) {
            self.Customer = JSON.parse(cus);
            if (so !== undefined && so !== null) {
              self.SalesOrg = JSON.parse(so);
            }
          }
          self.quoteData = QuoteDataModel.create({
            date: new Date(),
          });
        },
        saveLS: () => {
          window.localStorage.setItem("MatCus", JSON.stringify(self.Customer));
          window.localStorage.setItem("MatSO", JSON.stringify(self.SalesOrg));
        },
        setCustomer: (val) => {
          self.Customer = val;
          self.setSalesOrg(null);
        },
        setMsal: ({ instance, accounts }) => {
          self.instance = instance;
          self.accounts = accounts;
        },
        setSalesOrg: (val) => {
          self.SalesOrg = val;
        },
        setRelation: (val) => {
          self.relation = val;
        },
        setInco2: (val) => {
          self.inco2 = val;
        },
        changeSSP: (val) => {
          self.SSP = val;
        },
        changeSys: (val) => {
          self.sapSys = val;
        },
        changeLoading: (val) => {
          self.loading = val;
        },
        selectSSP: (val) => {
          self.SelectedSSP = val;
          if (val > -1) {
            self.quoteData.getQuotes(
              self.SSPItem.SoldTo,
              self.SSPItem.ShipTo,
              new Date()
            );
          }
        },
        selectQuote: (val) => {
          if (val) {
            let payOptions = {
              method: "POST",
              credentials: "same-origin",
              body: JSON.stringify({
                proj: "Z_GW_PROSPECT_SRV",
                funct: "PaymentTermSet",
                parameters: `$top=20&$filter=PaymentTermID eq '${val.Paymentterm}'&$format=json`,
              }),
            };
            let incoOptions = {
              method: "POST",
              credentials: "same-origin",
              body: JSON.stringify({
                proj: "Z_GW_PROSPECT_SRV",
                funct: "IncotermSet",
                parameters: `$top=20&$filter=IncotermID eq '${val.Incoterm1}'&$format=json`,
              }),
            };

            let shipOptions = {
              method: "POST",
              credentials: "same-origin",
              body: JSON.stringify({
                proj: "Z_GW_PROSPECT_SRV",
                funct: "ShippingConditionSet",
                parameters: `$top=20&$filter=ShippingConditionID eq '${val.Shipmentterm}'&$format=json`,
              }),
            };
            var sys = window.localStorage.getItem("QUOTEsys");
            let url = `SAPOData${sys}`;

            Promise.all([
              apiCall(url, payOptions, null, self.instance, self.accounts),
              apiCall(url, incoOptions, null, self.instance, self.accounts),
              apiCall(url, shipOptions, null, self.instance, self.accounts),
            ]).then(([pay, inco, ship]) => {
              self.SelectedQuote.change(
                ship.length > 0 ? ship[0].ShippingConditionDescription : "null",
                "ShipmenttermDesc"
              );
              self.SelectedQuote.change(
                inco.length > 0 ? inco[0].IncotermDescription : "null",
                "IncotermDesc"
              );
              self.SelectedQuote.change(
                pay.length > 0 ? pay[0].PaymentTermDescription : "null",
                "PaymenttermDesc"
              );
              console.log(self.SelectedQuote);
            });
            self.SelectedQuote = JSON.parse(
              JSON.stringify({
                ...val,
              })
            );
          } else {
            self.SelectedQuote = val;
          }
        },
        make: flow(function* make(type) {
          try {
            self.loading = true;
            let saverequest = {
              jsonquote: JSON.stringify({
                ...self.SelectedQuote,
                Internaltext: self.SelectedQuote.Internaltext.replace(
                  /<p>/g,
                  ""
                ).replace(/<\/p>/g, "\n"),
                Externaltext: self.SelectedQuote.Externaltext.replace(
                  /<p>/g,
                  ""
                ).replace(/<\/p>/g, "\n"),
                ValidTo: self.SelectedQuote.ValidTo.toDateString(),
                Validfrom: self.SelectedQuote.Validfrom.toDateString(),
                ReqDel: self.SelectedQuote.Validfrom.toDateString(),
              }),
              //jsonquote: JSON.stringify({ custnr: "55" }),
              sys: self.sapSys,
              type: type,
            };
            let bodypayload = JSON.stringify(saverequest);
            var sys = window.localStorage.getItem("QUOTEsys");
            let url = "Quote/CreateQuote" + sys;
            const response = yield apiCall(
              url,
              {
                method: "POST",
                credentials: "same-origin",
                body: bodypayload,
              },
              null,
              self.instance,
              self.accounts
            );
            console.log(response);
            document.location.href = response.BrowseUrl;
            self.loading = false;
          } catch (e) {
            console.log("Failed to save", e);
            self.loading = false;
          }
        }),
        getSSP: () => {
          self.loading = true;
          self.saveLS();
          self.selectSSP(-1);
          let fetchOptions = {
            method: "POST",
            credentials: "same-origin",

            body: JSON.stringify({
              proj: "Z_GW_ARCH_ORDER_SRV",
              funct: "CustomerSSPSet",
              parameters: `$top=20&$filter=SoldTo eq '${self.Customer.Id}' and SalesOrg eq '${self.SalesOrg.Id}'&$format=json`,
            }),
          };
          var sys = window.localStorage.getItem("QUOTEsys");
          let url = `SAPOData${sys}`;
          return apiCall(
            url,
            fetchOptions,
            (json) => {
              console.log(json);
              json.forEach((el) => {
                if (el.SoldTo.startsWith("0"))
                  el.SoldTo = parseInt(el.SoldTo).toString();
                if (el.Payer.startsWith("0"))
                  el.Payer = parseInt(el.Payer).toString();
                if (el.ShipTo.startsWith("0"))
                  el.ShipTo = parseInt(el.ShipTo).toString();

                el.SoldTo = el.SoldTo.trim();
                el.ShipTo = el.ShipTo.trim();
                el.Payer = el.Payer.trim();
              });
              self.changeLoading(false);
              self.changeSSP(json);
            },
            self.instance,
            self.accounts
          );
        },
      };
    })
);
